import { httpClient } from '@/modules/common/services/http/http-client';
import { ITransactionFilters } from './banking-types';
import { FeatureFlags } from '@/types/models/FeatureFlags';
import { FeatureFlagsModule } from '@/modules/common/store/FeatureFlagsModule';

const http = httpClient.withOptions({
  baseURL: process.env.VUE_APP_BFF_URL
});

export function getTransactionsReport(
  filters: ITransactionFilters
): Promise<BlobPart> {
  return http.get(`banking/v1/cash/getTransactionsReport`, {
    params: filters,
    responseType: 'blob'
  });
}

export function deleteScheduledTransaction(
  transactionId: string
): Promise<void> {
  const useNewEndpoint = FeatureFlagsModule.isEnabled(
    FeatureFlags.ENABLE_BFF_BANKING_MIGRATION
  );

  const endpoint = useNewEndpoint
    ? 'transactions/v1/statement/scheduled'
    : 'banking/v1/statement/scheduled';
  return http.delete(`${endpoint}/${transactionId}`);
}
